module.exports = __webpack_public_path__ + "media/images/ir/common/bnr-qa-station-d37b02c3d9583af0423666a80dda1c77.png";